import React from "react";
import "./styles.css";

const Footer = () => (
  <footer className="home-footer">
    <h2>دنیای نجوم</h2>
    <h1>
      <span>“</span> علامه حلی 6 <span>”</span>
    </h1>
    <p>
      تمامی محتوای این سایت محفوظ می باشد
    </p>
  </footer>
);

export default Footer;
